import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { categoriesMainData } from '../../data/data';
import { formCategory } from '../../features/firstLoginCategoryForm'
import { useDispatch } from 'react-redux'
export default function FirstLoginCategoryForm() {
    const { register, handleSubmit, formState: { errors }, getValues, reset
    } = useForm();
    const [sending, setSending] = useState(false)
    const [submitData, setSubmitData] = useState("");
    // const [selectData, setSelectData] = useState('')
    const [selectOnChangeData, setSelectSelectOnChangeData] = useState([])
    const [isOpen, setIsOpen] = useState(false);
    // open select field
    const toggle = () => {
        setIsOpen(!isOpen);
    };
    const dispatch = useDispatch()

    const onSubmit = async data => {
        setSending(true)
        setSubmitData(JSON.stringify(data));
    };
    useEffect(() => {
        // if data save data
        if (submitData && submitData.length > 0) {
            // hide loader
            setSending(false)
            // hide loader end
            // add data to store
            dispatch(formCategory({ category: getValues("categories") }))
            // add data to store end

            // reset value if success
            reset({
                categories: [],
            })
            setSelectSelectOnChangeData([])
        }
    }, [submitData])

    function handleCheckboxChange(e) {
        // create array from checked items else if item unchecked remove it
        if (e.target.checked) {
            setSelectSelectOnChangeData([...selectOnChangeData, e.target.value])
        } else {
            setSelectSelectOnChangeData(selectOnChangeData.filter(item => item !== e.target.value))
        }
    }

    return (
        <div>
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>
                <div className="dropdown-check-list relative" tabIndex="100">
                    <div className='text-formSubSize pb-2'>
                        Fields you’re most interested in
                    </div>
                    <div onClick={() => toggle()} className="border border-borderColor rounded text-formSmallText py-[5px] relative">
                        {
                            // show selected data if exist
                            selectOnChangeData && selectOnChangeData.length !== 0 ? <div className='line-one pl-4 pr-6'>
                                {
                                    selectOnChangeData.map((item, i) => (
                                        item + `${i !== selectOnChangeData.length - 1 && ','}`
                                    ))
                                }
                            </div> :
                                <div className='text-white opacity-60 px-4'>
                                    Select Fields
                                </div>
                        }
                        <span className="absolute right-4 top-[0.875rem]">
                            <img src={`/images/icons/arrow-down.svg`} alt="arrow" />
                        </span>
                    </div>
                    <ul className={`absolute w-full items z-10 font-dropdownFont  ${isOpen ? 'block' : 'hidden'}`}  >
                        {
                            categoriesMainData &&
                            categoriesMainData.map((item, i) => (
                                <li key={item.id}>
                                    <div className="flex relative">
                                        <label className="containerCheckboxDropdown border-b border-b-whiteBorderColor">
                                            <input type="checkbox" className="checkbox" value={item.name}
                                                {...register('categories', {
                                                    required: true,
                                                    onChange: (e) => handleCheckboxChange(e),
                                                })}
                                            />
                                            <div className="text-white checkboxText font-medium tracking-wider text-dropdownFontSize">{item.name}</div>
                                            <span className="checkMarkDropdown"></span>
                                        </label>
                                    </div>
                                </li>
                            ))
                        }

                    </ul>

                    {errors.categories && <span className="text-formSubSize absolute -bottom-[1.2rem] left-0 text-[#CA0000] pt-1 ">This field is required</span>}
                </div>
                <div className='pt-[5.25rem]'>

                    {
                        selectOnChangeData.length !== 0 ?

                            // if we are sending data show loader
                            sending ?
                                <div className="main-button w-fit">
                                    < svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div> :
                                // after or before send





                                <input type="submit" value={"Go to Dashboard"} className="main-button" />
                            :
                            <div className="main-button opacity-40 w-fit" >
                                Go to Dashboard
                            </div>
                    }
                </div>
            </form>
        </div>
    )
}
